import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { MenuItemsModel } from '@core/menu/menu.model';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { ParkingGuard } from '@core/auth/guards/parking.guard';
import { ClientSearchResolverService } from './shared/resolvers/client-search-resolver.service';

const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Clients,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Clients + '/:' + RoutingQueryParamsName.ClientId + '/' + RouteEntity.Parking,
        title: marker('modules.client.head'),
        loadChildren: () => import('./features/parking/parking.routes').then((r) => r.routes),
        canLoad: [AuthGuard, ParkingGuard],
        resolve: {
            client: ClientSearchResolverService,
        },
    },
    {
        path: RouteEntity.Clients,
        title: marker('modules.client.head'),
        loadChildren: () => import('./features/client/client.routes').then((r) => r.routes),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Refunds,
        title: marker('modules.refunds.head'),
        loadComponent: () => import('./features/refunds/refunds.component').then((c) => c.RefundsComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.CouponSearch,
        title: marker('global.labels.coupons'),
        loadComponent: () => import('./features/search-coupon/search-coupon.component').then((c) => c.SearchCouponComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.TicketSearch,
        title: marker('global.labels.tickets'),
        loadComponent: () => import('./features/search-ticket/search-ticket.component').then((c) => c.SearchTicketComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Messages,
        title: marker('modules.messages.head'),
        loadComponent: () => import('./features/messages/messages.component').then((c) => c.MessagesComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
